const MedicalHistoryElem = (data = {}) => ({
    labels: [],
    description: '',
    author: '',
    timestamp: '',
    ...data
});

export default MedicalHistoryElem;
